export default function isSameSummaryData(summary, metric) {
  // return summary?.length && summary?.[0]?.metrics?.[0].metric === metric;
  return summary?.length && summary?.[0]?.metrics?.some((summaryMetric) => summaryMetric.metric === metric);
}
